export const AppTheme = {
    active_color: "#307FE2"
}